'use strict';

module.exports = require('./core/');


//////////////////
// WEBPACK FOOTER
// ./~/modal-video/lib/index.js
// module id = 28
// module chunks = 0